<div class="dialog-data">
  <div class="dialog-header">
    <div>
      <h1 class="dialog-title">{{ "TRAINING_CONFIGURATION.DIALOG_TITLE" | translate }}</h1>
      <div class="dialog-subtitle">{{ "TRAINING_CONFIGURATION.VIDEO_CHOOSE_HEADING" | translate }}</div>
    </div>
    <button type="button" class="icon-btn" [disabled]="videoUploading" (click)="close()" aria-label="Close dialog">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>

  <div class="seg" role="tablist" aria-label="Video source">
    <button type="button" role="tab" class="seg-btn" [class.is-active]="playlistType === 'custom'" [attr.aria-selected]="playlistType === 'custom'" [disabled]="videoUploading" (click)="handleVideoType({value: 'custom'})">
      <span class="material-symbols-outlined">folder</span>
      {{ "CUSTOM_VIDEO.TYPE_HEADING" | translate }}
    </button>
    <button type="button" role="tab" class="seg-btn" [class.is-active]="playlistType === 'youtube'" [attr.aria-selected]="playlistType === 'youtube'" [disabled]="videoUploading" (click)="handleVideoType({value: 'youtube'})">
      <span class="material-symbols-outlined">smart_display</span>
      YouTube
    </button>
  </div>

  <div class="body-scroll">

    <div class="tab-panel" *ngIf="playlistType === 'youtube'">
      <div class="field-block">
        <label class="field-label" for="yt-url">
          {{ "TRAINING_CONFIGURATION.YOUTUBE_LINK" | translate }}
          <span class="material-symbols-outlined info-icon" tabindex="0" [ngbTooltip]="linkTooltip()">info</span>
        </label>
        <div class="input-row">
          <div class="input-shell">
            <span class="material-symbols-outlined">link</span>
            <input id="yt-url" class="field-input" type="text" [(ngModel)]="linkUrl" (input)="handlePlaylistType($event.target)" #linkInput placeholder="https://youtube.com/watch?v=…">
          </div>
          <button type="button" class="btn btn-outline" [hidden]="youtubeLinkType === 'videoId'" (click)="getPlaylist()">{{ "TRAINING_CONFIGURATION.GET_PLAYLIST" | translate }}</button>
        </div>
      </div>

      <div class="field-block">
        <label class="field-label" for="yt-name">
          {{ "TRAINING_CONFIGURATION.PLAYLIST_NAME" | translate }}
          <span class="material-symbols-outlined info-icon" tabindex="0" [ngbTooltip]="nameTooltip()">info</span>
        </label>
        <input id="yt-name" class="field-input no-icon" type="text" [(ngModel)]="playlistName" placeholder="{{ 'TRAINING_CONFIGURATION.NAME_PLACEHOLDER' | translate }}">
      </div>

      <button type="button" class="btn btn-outline open-youtube-btn" (click)="youtubeNavigate()">
        <span class="material-symbols-outlined">smart_display</span>
        {{ "TRAINING_CONFIGURATION.OPEN_TEXT" | translate }}
        <span class="material-symbols-outlined">open_in_new</span>
      </button>
    </div>

    <div class="tab-panel" *ngIf="playlistType === 'custom'">
      <ng-container *ngIf="currentUser?.role !== 'normal' && !selectedVideo">
        <div class="visibility-row">
          <span class="field-label">{{ "CUSTOM_VIDEO.VIDEO_TYPE" | translate }}</span>
          <div class="seg seg-compact">
            <button type="button" class="seg-btn" [class.is-active]="customVideoType === 'private'" [disabled]="videoUploading" (click)="customVideoType = 'private'">{{ "CUSTOM_VIDEO.VIDEO_PRIVATE" | translate }}</button>
            <button type="button" class="seg-btn" [class.is-active]="customVideoType === 'public'" [disabled]="videoUploading" (click)="customVideoType = 'public'">{{ "CUSTOM_VIDEO.VIDEO_PUBLIC" | translate }}</button>
          </div>
        </div>

        <label class="dropzone" [class.is-disabled]="getUserStorageUsed() >= 100">
          <span class="material-symbols-outlined">cloud_upload</span>
          <div class="dropzone-text">{{getUserStorageUsed() >= 100 ? ('CUSTOM_VIDEO.MAX_STORAGE_USED' | translate) : ('CUSTOM_VIDEO.DROP_TEXT' | translate)}}</div>
          <div class="dropzone-hint">{{ "CUSTOM_VIDEO.LIMIT_HINT" | translate }}</div>
          <input type="file" [multiple]="false" accept="video/mp4, video/WebM, video/Ogg" (change)="onFileChange($event)" [disabled]="getUserStorageUsed() >= 100" class="sr-only">
        </label>
        <p class="picked-file-name" *ngIf="videoName">{{videoName}}</p>

        <div class="storage-usage">
          <div class="field-label">{{ "CUSTOM_VIDEO.STORAGE_USED" | translate }} <span class="material-symbols-outlined">storage</span></div>
          <div class="progress-wrap">
            <mat-progress-bar mode="determinate" [value]="getUserStorageUsed()"></mat-progress-bar>
            <span class="storage-value">{{getUserStorageUsed()}}% ({{getUserStorageInMb()}} MB)</span>
          </div>
        </div>
      </ng-container>

      <button type="button" class="btn btn-ghost clear-selected-btn" *ngIf="selectedVideo" (click)="clearSelectedVideo()">{{ "TRAINING_CONFIGURATION.CLEAR_SELECTED" | translate }}</button>
    </div>

    <div class="divider-row">{{ "TRAINING_CONFIGURATION.PLAYLIST_HISTORY" | translate }}</div>

    <div class="search-shell">
      <span class="material-symbols-outlined">search</span>
      <label class="sr-only" for="history-search">{{ "TRAINING_CONFIGURATION.SEARCH_PLACEHOLDER" | translate }}</label>
      <input id="history-search" class="search-input" type="text" [(ngModel)]="historySearch" placeholder="{{ 'TRAINING_CONFIGURATION.SEARCH_PLACEHOLDER' | translate }}">
    </div>

    <div class="empty-state" *ngIf="historySearch && !hasAnyHistoryResults">{{ "TRAINING_CONFIGURATION.NO_RESULTS" | translate }}</div>

    <div class="history-group" *ngIf="playlistType === 'youtube' && playlistHistoryArray.length">
      <div class="group-label">{{ "TRAINING_CONFIGURATION.PRESET_PLAYLISTS" | translate }}</div>
      <ng-container *ngFor="let video of playlistHistoryArray">
        <div class="row-wrap" *ngIf="matchesSearch(video.name)" [class.is-selected]="choosenPlaylist && choosenPlaylist.url === video.url" (click)="getChoosenPlaylist({value: video}, true)">
          <button type="button" class="row" [disabled]="video.url && video.url.includes('shorts')">
            <span class="row-radio"></span>
            <span class="row-title">{{video.name}}</span>
            <button type="button" class="row-delete" *ngIf="currentUser?.role === 'super user' && video.isDefault" (click)="deleteYoutubeVideoSuperUser(video)">
              <span class="material-symbols-outlined">delete</span>
            </button>
            <button type="button" class="row-delete" *ngIf="currentUser?.role !== 'super user' && !video.isDefault" (click)="deleteYoutubeVideoFromHistory(video)">
              <span class="material-symbols-outlined">delete</span>
            </button>
            <iframe *ngIf="getPlaylistEmbedUrl(video.url) as embedUrl; else historyIcon" class="row-embed" [src]="embedUrl | safe:'resourceUrl'" frameborder="0" allowfullscreen tabindex="-1"></iframe>
            <ng-template #historyIcon>
              <span class="row-icon material-symbols-outlined">format_list_bulleted</span>
            </ng-template>
          </button>
        </div>
      </ng-container>
    </div>

    <div class="history-group" *ngIf="playlistType === 'custom' && userVideos.length">
      <div class="group-label" *ngIf="currentUser?.role !== 'normal'">{{ "CUSTOM_VIDEO.YOUR_VIDEOS" | translate }}</div>
      <ng-container *ngFor="let video of userVideos">
        <div class="row-wrap has-delete" *ngIf="matchesSearch(deleteVideoFormat(video.name))" [class.is-selected]="selectedVideo === video">
          <button type="button" class="row" [disabled]="videoUploading" (click)="setVideoFromList({value: video})">
            <span class="row-radio"></span>
            <span class="row-title">{{deleteVideoFormat(video.name) | titlecase}}</span>
          </button>
          <button type="button" class="row-delete" (click)="deleteVideo(video, 'private')">
            <span class="material-symbols-outlined">delete</span>
          </button>
          <div class="video-preview-wrap">
            <video #videoItem (loadeddata)="getVideoDuration($event, video, videoItem)" controls class="video-preview" [src]="video.videoPreview"></video>
            <span class="video-duration">{{video?.duration}}</span>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="history-group" *ngIf="playlistType === 'custom' && publicVideos.length">
      <div class="group-label">{{ "CUSTOM_VIDEO.PUBLIC_VIDEOS" | translate }}</div>
      <ng-container *ngFor="let video of publicVideos">
        <div class="row-wrap has-delete" *ngIf="matchesSearch(deleteVideoFormat(video.name))" [class.is-selected]="selectedVideo === video" (click)="setVideoFromList({value: video})">
          <button type="button" class="row" [disabled]="videoUploading">
            <span class="row-radio"></span>
            <span class="row-title">{{deleteVideoFormat(video.name) | titlecase}}</span>
            <span class="row-owner" *ngIf="video.ownerName">{{ 'CUSTOM_VIDEO.UPLOADED_TEXT' | translate }} {{video.ownerName}}</span>
          </button>
          <button type="button" class="row-delete" *ngIf="video.metadata === currentUser?.id" (click)="deleteVideo(video, 'public')">
            <span class="material-symbols-outlined">delete</span>
          </button>
          <div class="video-preview-wrap">
            <video #videoItem (loadeddata)="getVideoDuration($event, video, videoItem)" controls class="video-preview" [src]="video.videoPreview"></video>
            <span class="video-duration">{{video?.duration}}</span>
          </div>
        </div>
      </ng-container>
    </div>

  </div>

  <div class="dialog-footer">
    <button mat-raised-button type="button" class="btn btn-ghost" [disabled]="videoUploading" (click)="close()">{{ "TRAINING_CONFIGURATION.CLOSE_DIALOG" | translate }}</button>
    <button mat-raised-button type="button" class="btn btn-primary" [class.is-disabled]="isSaveDisabled()" [disabled]="isSaveDisabled()" (click)="confirm()">{{ "TRAINING_CONFIGURATION.SAVE_DIALOG" | translate }}</button>
  </div>
</div>

<div class="progress-upload" *ngIf="videoUploading && playlistType === 'custom'">
  <p>{{'CUSTOM_VIDEO.VIDEO_UPLOADING' | translate}}</p>
  <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
</div>
